import { ArrowLeft, ArrowRight } from "lucide-react";
import { SERVICE_LIST } from "@/lib/i18n";
import { computePricing } from "@/lib/pricing";

const range = (id) => {
  const r = computePricing({ service: id, experience: "intermediate", complexity: "medium", unit: "project", quantity: 1, revisions: 2, rush: false });
  const round = (n) => Math.round(n / 100) * 100;
  return [round(r.minPrice), round(r.maxPrice)];
};

export default function HeroQuickStart({ lang, dark, t, onPick }) {
  const ar = lang === "ar";
  const num = (n) => n.toLocaleString(ar ? "ar-SA" : "en-US");
  const Arrow = ar ? ArrowLeft : ArrowRight;
  return (
    <div data-testid="hero-quick-start" className={`mt-6 ${ar ? "font-arabic" : "font-outfit"}`}>
      <div className={`text-sm sm:text-base font-extrabold mb-2.5 ${dark ? "text-white" : "text-[#182138]"}`}>
        {ar ? "دليل أسعار سريع — اضغط على خدمتك لتعبئة الحاسبة" : "Quick price guide — tap your service to fill the calculator"}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {SERVICE_LIST.map((s, i) => {
          const [lo, hi] = range(s.id);
          return (
            <button
              key={s.id}
              type="button"
              data-testid={`hero-quick-${s.id}`}
              onClick={() => onPick(s.id)}
              style={{ animationDelay: `${i * 60}ms` }}
              className={`group text-start rounded-xl border px-3 py-2.5 transition-[transform,border-color,background-color] duration-200 hover:-translate-y-0.5 animate-in fade-in slide-in-from-bottom-2 fill-mode-both ${
                dark ? "bg-[#1f2a47]/80 border-[#2e3a5c] hover:border-[#18c98f]" : "bg-white border-[#e5e5ea] hover:border-[#18c98f]"
              }`}
            >
              <div className={`flex items-center justify-between gap-1 text-xs sm:text-[13px] font-bold ${dark ? "text-white/90" : "text-[#2d2c35]"}`}>
                <span className="truncate">{t.services[s.id]}</span>
                <Arrow className="h-3.5 w-3.5 shrink-0 text-[#18c98f] opacity-60 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="mt-1 text-[11px] sm:text-xs font-black text-[#18c98f] tabular-nums" data-testid={`hero-quick-range-${s.id}`}>
                {num(lo)} – {num(hi)} {ar ? "ر.س" : "SAR"}
              </div>
              <div className={`text-[10px] ${dark ? "text-white/45" : "text-[#2d2c35]/50"}`}>
                {ar ? "لمشروع متوسط" : "per mid-size project"}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
